import clsx from 'clsx'

import { useEffect, useMemo, useState } from 'preact/hooks'
import { sizeRanges, FIELD_MAPPING } from '../helpers/universalSizeMapping'

function sizeGroupsFromValues(values, selectedFilter) {
  const sizeType = FIELD_MAPPING[selectedFilter.field]
  const groups = Object.keys(sizeRanges)

  return groups.map((group) => {
    const groupValues = values.filter((value) => sizeRanges[group].some((range) => range[sizeType] === value.label))
    return {
      label: group,
      values: groupValues
    }
  })
}

function FilterInputSizingButton({ item, onClick }) {
  return (
    <button
      onClick={() => onClick(item.value)}
      disabled={item.disabled}
      class={clsx(
        'flex h-12 w-16 cursor-pointer flex-col items-center justify-center rounded-md border border-solid',
        item.checked ? 'bg-primary-blue text-white' : 'border-neutrals-tertiary-grey',
        item.disabled && 'cursor-not-allowed bg-neutrals-base text-neutrals-medium-grey'
      )}
    >
      {item.label}
    </button>
  )
}

const customSort = (a, b) => {
  // If one has leading zero and other doesn't, the one with leading zero is smaller
  if (a.startsWith('0') && !b.startsWith('0')) return -1
  if (!a.startsWith('0') && b.startsWith('0')) return 1
  // If both have leading zeros or both don't, compare normally
  return parseInt(a) - parseInt(b)
}

export function FilterInputSizing({ initialFilters, activeFilters, fetchedFilters, onFilter }) {
  if (!initialFilters || !initialFilters.length > 0) return null
  const [selectedSizeType, setSelectedSizeType] = useState(FIELD_MAPPING[initialFilters[0].field])

  const selectedFilter = useMemo(() => {
    return initialFilters.find((filter) => FIELD_MAPPING[filter.field] === selectedSizeType)
  }, [selectedSizeType])

  const fetchedFilter = useMemo(() => {
    return fetchedFilters.find((current) => current.field === selectedFilter.field)
  }, [fetchedFilters, selectedFilter])

  const values = useMemo(() => {
    return (
      selectedFilter.values.map((item) => {
        const valueWithKey = `${selectedFilter.field}:${item.value}`
        const fetchedValue = fetchedFilter?.values?.find((currentValue) => {
          return currentValue.label === item.label
        })
        return {
          label: item.label,
          value: valueWithKey,
          count: fetchedValue?.count,
          checked: activeFilters.has(valueWithKey),
          disabled: !fetchedValue
        }
      }) ?? []
    )
  }, [selectedFilter, activeFilters, fetchedFilter])

  const sortedValues = useMemo(() => {
    return values.sort((a, b) => customSort(a.label, b.label))
  }, [values])

  const groupedValues = useMemo(() => {
    return sizeGroupsFromValues(values, selectedFilter)
  }, [sortedValues])

  return (
    <div class="flex h-full flex-col overflow-y-scroll">
      <div className="sticky top-0 flex items-center rounded-full bg-primary-grey p-1">
        {initialFilters?.map((filter) => (
          <button
            key={filter.field}
            onClick={() => setSelectedSizeType(FIELD_MAPPING[filter.field])}
            className={clsx(
              'paragraph-sm text-neturals-secondary-grey w-full basis-full rounded-full px-4 py-2  text-center font-medium',
              FIELD_MAPPING[filter.field] === selectedSizeType && 'bg-primary-white'
            )}
          >
            {FIELD_MAPPING[filter.field]}
          </button>
        ))}
      </div>
      {selectedFilter &&
        groupedValues.map((ageGroup) => (
          <>
            {ageGroup?.values.length > 0 && (
              <div class="flex flex-col  gap-2 border-b border-solid border-b-neutrals-medium-grey py-8 ">
                <div className={'font-medium uppercase'}>{ageGroup.label}</div>
                <div className={'flex flex-row flex-wrap gap-2'}>
                  {ageGroup.values.map((item) => (
                    <FilterInputSizingButton key={item.value} item={item} onClick={onFilter} />
                  ))}
                </div>
              </div>
            )}
          </>
        ))}
    </div>
  )
}
